
<topbar> <h1 topbar-title>Site Checks Admin</h1> </topbar>

<page pTitle="Admin">
    <card>
        <card-section>
            <div class="card-section-item">
                <label> Select a branch:</label>
                <div class="admin-control">
                    <form-field>
                        <mat-select
                        class="btn__select"
                        name="status"
                        [(ngModel)]="locationSelected"
                        >
                        <mat-option
                            [value]="location"
                            *ngFor="let location of locations"
                        >
                            {{ location }}
                        </mat-option>
                        </mat-select>
                    </form-field>
                    
                </div>
                
                <input (click)="resetBranchSession()" [disabled]="!canResetBranchSession" value="Reset branch session" type="button" class="btn admin-control" />
            </div>
            <hr class="card-section-item">
            <div class="card-section-item">
                <a class="btn admin-control" routerLink="/site-checks/schedule">
                    Create new schedule
                </a>
            </div>
            
            <div class="card-section-item">
                <schedule-list>
                </schedule-list>
            </div>
        </card-section>
    </card>
</page>